import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  margin: 5px 0;\n  color: ", ";\n  max-width: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  padding: 20px 0;\n  line-height: 20px;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n\n  &:after {\n    background-size: 12px 9px;\n    background: url(\"", "\") no-repeat center center;\n    content: '';\n    display: block;\n    height: 20px;\n    width: 20px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import Check from '../check.svg';
var CheckMark = styled.div(_templateObject(), function (props) {
  return props.theme.colors.green;
}, function (props) {
  return props.theme.borderRadius.large;
}, Check);
var OptionContainer = styled.div(_templateObject2());
var OptionTextContainer = styled.div(_templateObject3());
var OptionTitle = styled.div(_templateObject4());
var OptionSubtext = styled.p(_templateObject5(), function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.selected ? 'calc(100% - 10px);' : 'calc(100% - 30px);';
});
export var DefaultOption = function DefaultOption(_ref) {
  var label = _ref.label,
      selected = _ref.selected,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(OptionContainer, {
    className: className
  }, label, selected && /*#__PURE__*/React.createElement(CheckMark, null));
};
export var SubtextOption = function SubtextOption(_ref2) {
  var label = _ref2.label,
      selected = _ref2.selected,
      subtext = _ref2.subtext,
      className = _ref2.className;
  return /*#__PURE__*/React.createElement(OptionContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(OptionTextContainer, null, /*#__PURE__*/React.createElement(OptionTitle, null, label), /*#__PURE__*/React.createElement(OptionSubtext, {
    selected: selected
  }, subtext)), selected && /*#__PURE__*/React.createElement(CheckMark, null));
};